import React from "react";
import GenericB2BList, { B2B_TYPES } from "../B2B/GenericB2BList";
import B2BPrecouponGiftModal from "../../../Components/modal/B2BPrecouponGiftModal";

/**
 * B2B Pre-Coupon List - uses GenericB2BList with precoupon configuration
 */
function B2BPreCouponList({ todayOnly }) {
  return (
    <GenericB2BList
      type={B2B_TYPES.PRECOUPON}
      GiftModalComponent={B2BPrecouponGiftModal}
      todayOnly={todayOnly}
    />
  );
}

export default B2BPreCouponList;
